import { apiGet, apiPatch } from '../../utils/api';
import { config } from '../../config/app-config';
import { isAuthenticated } from '../auth';
import { showErrorNotification, showSuccessNotification } from '../../utils/notifications';
import { openLinkPageModal } from '../diagnostic-manager/link-page-modal';

export class ExpertiseManager {
    constructor() {
        document.addEventListener('DOMContentLoaded', () => this.processExistingBlocks());
    }

    _activateLink(blockElement, slug) {
        const link = blockElement.querySelector('a.expertise-learn-more');
        if (!link) return;

        if (slug) {
            link.href = `/diagnostic/${slug}`;
            link.classList.remove('inactive');
            link.classList.add('active');
        } else {
            link.href = '#';
            link.classList.remove('active');
            link.classList.add('inactive');
        }
    }

    addLinkButton(blockElement) {
        if (!isAuthenticated()) return;
        if (blockElement.querySelector('.expertise-link-btn')) return;

        const btn = document.createElement('button');
        btn.className = 'expertise-link-btn block-control-btn';
        btn.title = 'Прив\'язати сторінку';
        btn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
                <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
            </svg>
        `;
        Object.assign(btn.style, {
            position: 'absolute',
            top: '8px',
            right: '32px',
            background: 'rgba(0,0,0,0.5)',
            border: 'none',
            borderRadius: '4px',
            color: 'white',
            cursor: 'pointer',
            padding: '4px',
            zIndex: '10',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        });

        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const blockId = blockElement.getAttribute('data-block-id');
            const currentSlug = blockElement.getAttribute('data-diagnostic-slug') || null;
            openLinkPageModal(blockId, currentSlug, (service) => {
                blockElement.setAttribute('data-diagnostic-id', service.id);
                blockElement.setAttribute('data-diagnostic-slug', service.slug);
                this._activateLink(blockElement, service.slug);
            });
        });

        blockElement.appendChild(btn);
    }

    processExistingBlocks() {
        document.querySelectorAll('[data-block-name^="expertise-card-"]').forEach(el => {
            const slug = el.getAttribute('data-diagnostic-slug');
            if (slug) {
                this._activateLink(el, slug);
            } else {
                const blockId = el.getAttribute('data-block-id');
                if (blockId) this._loadBlockData(el, blockId);
            }

            if (isAuthenticated()) this.addLinkButton(el);
        });
    }

    async _loadBlockData(blockElement, blockId) {
        try {
            const data = await apiGet(`${config.api.paths.diagnosticsByBlockId}/${blockId}`, { auth: false });
            if (data?.slug) {
                blockElement.setAttribute('data-diagnostic-id', data.id);
                blockElement.setAttribute('data-diagnostic-slug', data.slug);
                this._activateLink(blockElement, data.slug);
            }
        } catch {
            // No diagnostic linked yet — link stays inactive
        }
    }
}

export const expertiseManager = new ExpertiseManager();
window.expertiseManager = expertiseManager;
